import * as actionType from "../constants";

export const isFilterReset = (input) => (dispatch) => {
  dispatch({ type: actionType.IS_RESET_FILTER, payload: input });
};
